export const E2E_IDENTITY_STORAGE_KEY = 'e2e_identity';

export function isE2EAuthBypassEnabled() {
  return import.meta.env.VITE_E2E_AUTH_BYPASS === 'true';
}

